import React, { Fragment } from 'react'
import injectSheet from 'react-jss'
import styles from './tags-input.styles'
import Select from 'react-select'
import classNames from 'classnames'
import CloseIcon from 'react-icons/lib/fa/times-circle'
import Tooltip from 'pobble-components/dist/tooltip'
import PropTypes from 'prop-types'
import uniqBy from 'lodash/uniqBy'

const TagsInput = ({ classes, className, creatable, ...props }) => {
  const Component = creatable ? Select.AsyncCreatable : Select.Async
  return (
    <Component
      valueComponent={conf => {
        const { value, disabled, onClick, onRemove } = conf
        const WrapperComponent = value.tooltip ? Tooltip : Fragment
        const props = value.tooltip ? { content: value.tooltip } : {}
        return (
          <WrapperComponent {...props}>
            <div
              style={{
                backgroundColor: value.bgColor,
                borderColor: value.borderColor,
                color: value.color
              }}
              className={classes.tag}>
              <span>{value.label}</span>
              <CloseIcon
                style={{ color: value.iconColor }}
                onMouseDown={e => {
                  if (!disabled) {
                    onClick && onClick(e)
                    onRemove(value)
                  }
                  e.stopPropagation()
                }}
                className={classes.tagClose}
              />
            </div>
          </WrapperComponent>
        )
      }}
      optionRenderer={(option, i) => (
        <span
          className={classNames(classes.option, {
            [classes.oddOption]: i % 2 !== 0
          })}>
          {option.label}
        </span>
      )}
      inputProps={{
        onPaste: event => {
          const paste = (event.clipboardData || window.clipboardData).getData(
            'text'
          )
          const pastedItems = paste
            .split(/[\r\n,]/)
            .map(t => t.trim())
            .filter(t => t.length > 0)

          if (pastedItems.length > 1) {
            event.preventDefault()
            props.onChange(
              uniqBy(
                [
                  ...props.value,
                  ...pastedItems.map(value => ({ value, label: value }))
                ],
                ({ value }) => value
              )
            )
          }
        }
      }}
      promptTextCreator={label => `Create tag ${label}`}
      backspaceToRemoveMessage=""
      multi={true}
      clearable={false}
      className={classNames(classes.container, className)}
      {...props}
    />
  )
}

TagsInput.propTypes = {
  /** Set to true if you want to allow creation of new tags */
  creatable: PropTypes.bool,
  /** Function that returns promise that resolves with a list of predefined options */
  loadOptions: PropTypes.func.isRequired,
  /**
   * All other props will be passed directly to React Select instance
   * Check the documentation for more info https://v1.react-select.com/
   */
  props: PropTypes.any
}

export default injectSheet(styles)(TagsInput)
